<div class="rule-row" [class.rule-row--clickable]="violations.length > 0" (click)="toggle()">
  <div class="rule-row__main">
    <span
      class="rule-row__chip"
      [class.rule-row__chip--pass]="result?.passed"
      [class.rule-row__chip--fail]="result && !result.passed"
    >
      {{ result?.passed ? 'Passed' : 'Failed' }}
    </span>
    <span class="rule-row__label">{{ ruleKey | driverRuleName }}</span>
    <span class="rule-row__count" *ngIf="violations.length > 0">
      {{ violations.length }} {{ violations.length === 1 ? 'violation' : 'violations' }}
    </span>
    <mat-icon *ngIf="violations.length > 0" class="rule-row__caret">
      {{ expanded ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  </div>
  <div class="rule-row__violations" *ngIf="expanded">
    <ng-container *ngFor="let v of violations; trackBy: trackByIndex">
      <div class="rule-row__violation" *ngIf="hasFriendlyShape(v); else rawTpl">
        <div class="rule-row__violation-head">
          <span class="rule-row__violation-order">Load #{{ getOrderId(v) }}</span>
          <span class="rule-row__violation-time" *ngIf="getEventTime(v) as t">
            {{ t | date: 'MMM d, y, h:mm a' }}
          </span>
        </div>
        <p class="rule-row__violation-detail">{{ getDescription(v) }}</p>
        <blockquote class="rule-row__violation-reason" *ngIf="getReason(v) as reason">
          Driver's reason: "{{ reason }}"
        </blockquote>
        <p class="rule-row__violation-status" *ngIf="getStatusNote(v) as status">{{ status }}</p>
      </div>
      <ng-template #rawTpl>
        <pre class="rule-row__violation-raw">{{ renderViolation(v) }}</pre>
      </ng-template>
    </ng-container>
  </div>
</div>
